import React from 'react';
import Utils from '../shared/Utils';
import ExamFilterContainer from '../shared/ExamFilterContainer';
import ResultsCountSwitcher from './CountSwitcher';
import YearTermSwitcher from './YearTermSwitcher';

class ResultsSwitcher extends React.PureComponent {
  handleExamClick = (index) => {
    this.props.changeExam(index);
  }

  render() {
    const {
      fetching,
      is_preview,
      active_year,
      active_term_as_int,
      active_exam_name,
      changeCount,
      years_and_terms
    } = this.props;


    const titleKey = is_preview ? 'titles.results_preview' : 'results.title';
    const term = Utils.getTerm(active_term_as_int);
    const subtitle = [active_year, term, active_exam_name].join(' ');
    const activeYearTermCombo = [active_year, term].join(' ');

    return (
      <div className='container'>
        <div className='jumbotron bg-faded-stay push-large' id='results-switcher'>
          <h3 className='text-center' children={Utils.t(titleKey)} />
          <h4 className='text-center space-bottom blue-text' children={subtitle} />

          <ExamFilterContainer
            fetching={fetching}
            examNames={Utils.allExamNames()}
            activeExamName={active_exam_name}
            handleClick={this.handleExamClick}
          />

          <hr />

          {is_preview
            ? <ResultsCountSwitcher
                count_indiv={this.props.count_indiv}
                count_team={this.props.count_team}
                fetching={fetching}
                changeCount={changeCount}
              />
            : <YearTermSwitcher
                {...this.props}
                yearsAndTerms={years_and_terms}
                activeYearTermCombo={activeYearTermCombo}
              />}
        </div>
      </div>
    );
  }
}

export default ResultsSwitcher;
